export const parseLastPathVariable = (location: string) => {
  return location.split('/').at(-1)
}
